var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
if(typeof window !== 'undefined' )
    var ui_extensions = require("ui-extensions");
var editor_2d = require("editor-2d");
var cio_config = require("cio-config");

var PadInteractionModel = function(data, editorModel) {
    editor_2d.AbstractPosAngleInteractionModel.call(this, data, editorModel);

    this.editorModel = editorModel;
    this.boundingBox = this.data.boundingBox;

    this.showName = this.shadow("showName",
        function () {
            return this.data.name();
        },
        function (value) {
            return this.data.name(value);
        },
        [this.data.name]
    );

    // TODO: once padstack can be swapped & modified this function will need to be called again & cleaning should be added
    this.addPadstackShadows();
};
lib_core.inherit(PadInteractionModel, editor_2d.AbstractPosAngleInteractionModel);
lib_core.JsonParser.registerClass(PadInteractionModel, "PadInteractionModel");

module.exports = PadInteractionModel;

PadInteractionModel.prototype.addPadstackShadows = function () {
    if(this.data.padstack() instanceof cio_datamodel.SmdPadstackData ||
       this.data.padstack() instanceof cio_datamodel.PthPadstackData) {
        var shape = this.data.padstack().topCopper();

        this.showWidth = this.shadow("showWidth",
            function () {
                return shape.width() / this.origin.getGridFactor();
            },
            function (value) {
                return shape.width((value || 0) * this.origin.getGridFactor());
            },
            [shape.width, [this.origin, this.origin.onBubble]]
        );

        this.showHeight = this.shadow("showHeight",
            function () {
                return shape.height() / this.origin.getGridFactor();
            },
            function (value) {
                return shape.height((value || 0) * this.origin.getGridFactor());
            },
            [shape.height, [this.origin, this.origin.onBubble]]
        );

        if(shape instanceof cio_datamodel.RectangleData){
            this.showRoundness = this.shadow("showRoundness",
                function () {
                    return shape.rx() / this.origin.getGridFactor();
                },
                function (value) {
                    var r = Math.abs(value || 0) * this.origin.getGridFactor();
                    if (r >= shape.width() / 2 || r >= shape.height() / 2) {
                        r = Math.min(shape.width(), shape.height()) / 2;
                    }
                    return shape.rx(r) && shape.ry(r);
                },
                [shape.rx, shape.ry, [this.origin, this.origin.onBubble]]
            );
        }
    }

    var hole = this.data.padstack().hole ? this.data.padstack().hole() : null;
    if(hole) {
        var hole_shape = hole.shape();
        if(hole_shape instanceof cio_datamodel.EllipseData && hole_shape.width() === hole_shape.height()) {
            this.holeDiameter = this.shadow("holeDiameter",
                function () {
                    return hole_shape.width() / this.origin.getGridFactor();
                },
                function (value) {
                    hole_shape.width((value || 0) * this.origin.getGridFactor());
                    hole_shape.height((value || 0) * this.origin.getGridFactor());
                },
                [hole_shape.width, hole_shape.height, [this.origin, this.origin.onBubble]]
            );
        }

        this.holeX = this.shadow("holeX",
            function () {
                return hole.pos().x / this.origin.getGridFactor();
            },
            function (value) {
                var new_pos = hole.pos().copy();
                new_pos.x = (value || 0) * this.origin.getGridFactor() ;
                hole.pos(new_pos);
            },
            [hole.pos, [this.origin, this.origin.onBubble]]
        );

        this.holeY = this.shadow("holeY",
            function () {
                return hole.pos().y / this.origin.getGridFactor();
            },
            function (value) {
                var new_pos = hole.pos().copy();
                new_pos.y = (value || 0) * this.origin.getGridFactor() ;
                hole.pos(new_pos);
            },
            [hole.pos, [this.origin, this.origin.onBubble]]
        );
    }

    if(this.data.padstack().maskExpansion) {
        this.showMaskExpansion = this.shadow("showMaskExpansion",
            function () {
                return this.data.padstack().maskExpansion() / this.origin.getGridFactor();
            },
            function (value) {
                var newValue = value * this.origin.getGridFactor();
                this.data.padstack().maskExpansion(newValue);
            },
            [this.data.padstack().maskExpansion, [this.origin, this.origin.onBubble]]
        );
    }

    if(this.data.padstack().pasteExpansion) {
        this.showPasteShrinkage = this.shadow("showPasteShrinkage",
            function () {
                return -1*(this.data.padstack().pasteExpansion() / this.origin.getGridFactor());
            },
            function (value) {
                var newValue = -1*(value * this.origin.getGridFactor());
                this.data.padstack().pasteExpansion(newValue);
            },
            [this.data.padstack().pasteExpansion, [this.origin, this.origin.onBubble]]
        );
    }

    if(this.data.padstack() instanceof cio_datamodel.SmdPadstackData) {
        this.showLayer = this.shadow("showLayer",
            function () {
                return this.data.onTopLayer() ? "TOP" : "BOTTOM";
            },
            function (value) {
                if(value == "TOP") this.data.onTopLayer(true);
                else if (value == "BOTTOM") this.data.onTopLayer(false);
            },
            [this.data.onTopLayer]
        );
    }
};

PadInteractionModel.prototype.getInspectorElements = function (readOnly) {
    var inspectorElements = editor_2d.AbstractPosAngleInteractionModel.prototype.getInspectorElements.call(this);

    var gridUnit = this.origin.getGridUnitString();

    inspectorElements.input_elements.unshift(
        {
            label      : 'Name',
            type       : ui_extensions.InspectorInputType.TEXT,
            datamember : this.showName,
            update_while_typing: true,
            non_combinable: true
        }
    );

    if(this.showWidth && this.showHeight) {
        inspectorElements.input_elements.push(
            {
                label      : 'Width',
                type       : ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
                datamember : this.showWidth,
                datatype   : cio_config.types.positive_float,
                unit       : gridUnit
            },
            {
                label      : 'Height',
                type       : ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
                datamember : this.showHeight,
                datatype   : cio_config.types.positive_float,
                unit       : gridUnit
            });
    }

    if(this.showRoundness) {
        inspectorElements.input_elements.push(
            {
                label      : 'Roundness',
                type       : ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
                datamember : this.showRoundness,
                datatype   : cio_config.types.positive_float,
                unit       : gridUnit
            }
        );
    }

    if(this.holeDiameter) {
        inspectorElements.input_elements.push({
            label       : 'Hole Diameter',
            type        : ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
            datamember  : this.holeDiameter,
            datatype    : cio_config.types.positive_float,
            unit        : gridUnit
        });
    }

    if(this.holeX && this.holeY) {
        inspectorElements.input_elements.push({
            label       : 'Hole Offset X',
            type        : ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
            datamember  : this.holeX,
            datatype    : cio_config.types.float,
            unit        : gridUnit
        });

        inspectorElements.input_elements.push({
            label       : 'Hole Offset Y',
            type        : ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
            datamember  : this.holeY,
            datatype    : cio_config.types.float,
            unit        : gridUnit
        });
    }

    if(this.data.padstack().maskEnable) {
        inspectorElements.input_elements.push(
            {
                label       : 'Enable Soldermask',
                type        : ui_extensions.InspectorInputType.CHECKBOX,
                datamember  : this.data.padstack().maskEnable
            }
        );
    }

    if(this.data.padstack().maskOverride) {
        inspectorElements.input_elements.push(
            {
                label       : 'Override Soldermask Expansion',
                type        : ui_extensions.InspectorInputType.CHECKBOX,
                datamember  : this.data.padstack().maskOverride
            }
        );
    }

    if(this.showMaskExpansion) {
        inspectorElements.input_elements.push({
            label       : 'SolderMask Expansion',
            type        : ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
            datamember  : this.showMaskExpansion,
            datatype    : cio_config.types.float,
            unitmember  : this.origin.showUnitString
        });
    }

    if(this.data.padstack().pasteEnable) {
        inspectorElements.input_elements.push(
            {
                label       : 'Enable Solderpaste',
                type        : ui_extensions.InspectorInputType.CHECKBOX,
                datamember  : this.data.padstack().pasteEnable
            }
        );
    }

    if(this.data.padstack().pasteOverride) {
        inspectorElements.input_elements.push(
            {
                label       : 'Override Solderpaste Shrinkage',
                type        : ui_extensions.InspectorInputType.CHECKBOX,
                datamember  : this.data.padstack().pasteOverride
            }
        );
    }

    if(this.showPasteShrinkage) {
        inspectorElements.input_elements.push({
            label       : 'SolderPaste Shrinkage',
            type        : ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
            datamember  : this.showPasteShrinkage,
            datatype    : cio_config.types.float,
            unitmember  : this.origin.showUnitString
        });
    }

    if(this.showLayer) {
        inspectorElements.input_elements.push({
            label      : 'Layer',
            type       : ui_extensions.InspectorInputType.SELECTBOX,
            list       : ["TOP", "BOTTOM"],
            datamember : this.showLayer,
        });
    }

    if(this.data.padstack().connectionType) {
        var list = [];
        for (var type in cio_datamodel.ThermalConnectionTypes) {
            list.push([cio_datamodel.ThermalConnectionTypes[type], cio_datamodel.ThermalConnectionTypes[type]]);
        }
        inspectorElements.input_elements.push({
            label      : 'Connection Type',
            type       : ui_extensions.InspectorInputType.SELECTBOX,
            list       : list,
            datamember : this.data.padstack().connectionType,
        });
    }

    inspectorElements.help_elements = {
        'name': 'Pad'
    };

    return inspectorElements;
};

